import { mapGetters } from 'vuex'

export const FieldErrorMessagesMixin = {
  computed: {
    ...mapGetters({
      formData: 'formData/formData',
      fieldSettings: 'legacy/fieldSettings'
    }),

    formFields () {
      return this.fieldSettings(this.formData.calendarIndex)
    },
    areRequiredFieldsOnStepC () {
      // Currently, we hardcode the fields on each screen. If this changes, then update this method.
      const fields = this.formFields

      return fields?.insuranceProviderId?.required ||
        fields?.insuranceIdNumber?.required ||
        fields?.insuranceGroupNumber?.required ||
        (this.showField('insuranceProviderId') && fields?.insurancePhone?.required) ||
        fields?.comment?.required
    }
  },
  methods: {
    validPhone (phone, allowNull = false) {
      if (!phone && !allowNull) {
        return false
      } else if (!phone && allowNull) {
        return true
      }
      return phone.replace(/[^0-9]/g, '').length === 10
    },
    isRequired (field) {
      return !!(!this.formFields?.[field]?.hide && this.formFields?.[field]?.required)
    },
    showField (field) {
      return !this.formFields?.[field]?.hide
    },
    getErrorMessages (field) {
      const errors = []
      if (!this.$v.formData[field].$dirty) {
        return errors
      }

      // Required error message
      !this.$v.formData[field].required && errors.push('Required')

      // if there is minimum length
      if (this.$v.formData[field].$params.minLength) {
        !this.$v.formData[field].minLength && errors.push(`Minimum ${this.$v.formData[field].$params.minLength.min} characters`)
      }

      // if its alpha numeric
      if (this.$v.formData[field].$params.alphaWithQuotes) {
        !this.$v.formData[field].alphaWithQuotes && errors.push('Only alphabetical characters')
      }

      // Default error message
      if (this.$v.formData[field].$invalid && errors.length === 0) {
        errors.push('Please enter a valid value')
      }

      return errors
    },
    scrollToView (event) {
      event.target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
    }
  }
}
